import React from "react";

import "../../pix/pix-row/Style.css"
import { BsFillPersonFill } from "react-icons/bs";
import { GrAdd } from "react-icons/gr";
import { BsTrashFill } from "react-icons/bs";
import enums from '../../../../services/enums'
import { deleteKey } from "../../../../services/pix.service";
import { useNavigate } from "react-router-dom";

export default function(props){
    const navigate = useNavigate()
    let type = props.data.type
    let displayKeyType = enums.pixTypes.filter((item)=>{
        return item.key == type
    })
    return(
        <div className="chaves mb-3">
            <div className="row">
                <div className="col-xl-2">
                    <BsFillPersonFill />
                </div>

                <div className="col-xl-8">
                    <h3>{displayKeyType[0].value}</h3>
                    <p>{props.data.key}</p>
                </div>
                <div className="col-xl-2 d-flex align-items-center justify-content-center">
                    <button className="deleteButton" onClick={()=>deleteKey(props.data.id, navigate)}>
                        <BsTrashFill size={20}/>
                    </button>
                </div>
            </div>
        </div>
    )
}